import dataLayer from '@helpers/dataLayer';
import { WebinarsState } from '@pages/Webinars/Webinar.slice';
import { WebinarItem } from '@pages/Webinars/Webinars.types';

export const doDataLayerPush = (webinarData: WebinarItem, filters: WebinarsState['filter']) => {
  const getCategoryName = (category: string) => {
    if (category === 'All') {
      const allCategoriesNames = webinarData.CategoryIndustryItems.map(
        ({ CategoryName }) => CategoryName
      );
      return allCategoriesNames.join(',');
    }

    const selectedCategory = webinarData.CategoryIndustryItems.find(
      ({ CategoryID }) => category === CategoryID.toString()
    );
    return selectedCategory.CategoryName;
  };

  dataLayer.push('webinar_button', {
    webinar_type: filters.type === 'All' ? webinarData.WebinarStatus : filters.type,
    webinar_industry: getCategoryName(filters.category),
    webinar_title: webinarData?.Heading || '',
  });
};
